<template>
  <div class="iBusiness-body">
    <section class="fluid">
      <h3 class="title">
        <span class="block pst">
          会话详情
        </span>
      </h3>
        <div class="chat-wrapper session-detail">
          <div class="chat-content">
            <div class="chat-block">
              <div class="title">
                <div>
                  <span>会话记录</span>
                </div>
                <div class="title-self">
                  <el-tooltip class="item" effect="light" content="导出会话详情" placement="bottom">
                    <span class="link" @click="exportHistories" v-if="this.$authUtis.hasButtonAuth('aicc-bp', '/chathistory/export_get')">
                      <!--导出会话记录-->
                      <svg class="icon" aria-hidden="true" style="margin-left: 0">
                        <use xlink:href="#icondaochuhuihuajilu" />
                      </svg>
                    </span>
                  </el-tooltip>
                  <el-tooltip class="item" effect="light" content="返回" placement="bottom">
                    <span class="link" @click="goBack">
                      <!--返回会话明细列表-->
                      <svg class="icon" aria-hidden="true" style="margin-left: 0">
                        <use xlink:href="#iconfanhui" />
                      </svg>
                    </span>
                  </el-tooltip>
                </div>
              </div>
              <div class="chat-box" style="min-height: 670px;overflow-x:visible;">
                <div class="chat-news" ref="chatNews">
                  <div v-for="(item, index) in list" :key="index" :class="item.d === 'up' ? 'questioner' : 'answerer'" class="block">
                    <p class="inform">
                      <template v-if="item.d === 'up'">
                        <span class="username">{{ item.uname ? item.uname : '客户' }}</span>
                        <span>{{ item.t }}</span>
                      </template>
                      <template v-else>
                        <span>{{ item.t }}</span>
                        <span class="username">{{ item.agent.name ? item.agent.name : '客服' }}</span>
                      </template>
                    </p>
                    <div class="news-wrap">
                      <template v-if="item.d === 'up'">
                        <div class="news-avator">
                          <svg class="icon" aria-hidden="true">
                            <use :xlink:href="'#icon'+ (item.d === 'up' ? 'user-head' : 'kefu-head')" />
                          </svg>
                        </div>
                        <div class="news" v-viewer>
                          <p v-html="translateMessage(item.type, item.msg)"/>
                        </div>
                      </template>
                      <template v-else>
                        <div class="news" v-viewer>
                          <p v-html="translateMessage(item.type, item.msg)"/>
                        </div>
                        <div class="news-avator">
                          <svg class="icon" aria-hidden="true">
                            <use :xlink:href="'#icon'+ (item.d === 'up' ? 'user-head' : 'kefu-head')" />
                          </svg>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="widgets">
              <div class="widgets-title">
                <span>会话概要</span>
              </div>
            <div class="widgets-content">
              <div class="list-block">
                <div class="widgets-subtitle">
                  <h5>访客信息</h5>
                </div>
                <div class="list-content">
                  <div class="form">
                    <div class="form-item">
                      <label class="item-label">访客ID</label>
                      <div class="item-text">{{ this.$route.query.userId }}</div>
                    </div>
                    <div class="form-item">
                        <label class="item-label">名称</label>
                        <div class="item-text">{{ userInfo.nameCn }}</div>
                    </div>
                    <div class="form-item">
                      <label class="item-label">客户等级</label>
                      <div class="item-text">{{ userInfo.level === 1 ? 'VIP' : '普通' }}</div>
                    </div>
                    <div class="form-item">
                      <label class="item-label">联系电话</label>
                      <div class="item-text">{{ userInfo.phone }}</div>
                    </div>
                    <div class="form-item">
                      <label class="item-label">邮箱</label>
                      <div class="item-text">{{ userInfo.email }}</div>
                    </div>
                    <div class="btn-wrapper">
                      <button class="btn" type="button" @click="searchSlog" v-if="this.$authUtis.hasButtonAuth('aicc-bp', '/chathistory/list_get')">查看该访客历史会话记录</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="list-block">
                <div class="widgets-subtitle">
                  <h5>会话信息</h5>
                </div>
                <div class="list-content">
                  <div class="form">
                    <div class="form-item">
                      <label class="item-label">会话ID</label>
                      <div class="item-text">{{ this.$route.query.sessionId }}</div>
                    </div>
                    <div class="form-item">
                      <label class="item-label">会话开始时间</label>
                      <div class="item-text">{{ this.$route.query.startTime }}</div>
                    </div>
                    <div class="form-item">
                      <label class="item-label">会话结束时间</label>
                      <div class="item-text">{{ this.$route.query.endTime }}</div>
                    </div>
                    <div class="form-item">
                      <label class="item-label">会话时长</label>
                      <div class="item-text">{{ this.$route.query.sessionTime }}</div>
                    </div>
                    <div class="form-item">
                      <label class="item-label">接待坐席</label>
                      <div class="item-text">{{ this.$route.query.agentNames }}</div>
                    </div>
                    <div class="form-item">
                      <label class="item-label">接入渠道</label>
                      <div class="item-text">{{ this.$route.query.platform }}</div>
                    </div>
                    <!-- <div class="form-item">
                      <label class="item-label">满意度评价</label>
                      <div class="item-text">满意</div>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <iframe v-show="false" src="" name="hide_iframe" width="0" height="0" frameborder="0" scrolling="no"/>
    </section>
  </div>
</template>
<script>
import { mapState } from 'vuex'
// import '../../styles/session/chatHistory/iconfont.js'
// import { getChatHistories, exportChatHistories } from '@/api/chatHistory'
import { getClientInfo } from '@/api/widgets'
export default {
  data() {
    return {
      list: [],
      limit: 50,
      page: 0,
      loading: false,
      islast: true,
      userInfo: {
        nameCn: '',
        level: '',
        phone: '',
        email: ''
      },
      resourceDownloadPath: window.$envUtils('VUE_APP_BASE_URL') + window.$envUtils('VUE_APP_WB_SERVICE') + '/res/download'
    }
  },
  mounted() {
    this.getList(0)
    if (this.hasApp('aicc-crm')) {
      this.getUserIofo()
    }
    this.$refs.chatNews.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    this.$refs.chatNews.removeEventListener('scroll', this.handleScroll)
  },
  computed: {
    ...mapState([
      'emojis'
    ])
  },
  methods: {
    handleScroll() {
      if (!this.loading && !this.islast) {
        // 滚动到页面底部时
        const scrollTop = this.$refs.chatNews.scrollTop
        const clientHeight = this.$refs.chatNews.clientHeight
        const scrollHeight = this.$refs.chatNews.scrollHeight
        const toBottom = scrollHeight - clientHeight - scrollTop
        if (toBottom <= 100) {
          this.loading = true
          this.page++
          this.getList(this.page)
        }
      }
    },
    getList(_page) {
      const params = {
        agentId: this.$route.query.agentIds.toString(),
        sessionId: this.$route.query.sessionId,
        page: _page,
        limit: this.limit
      }
      this.$http.get(window.$envUtils('VUE_APP_WB_SERVICE') + '/chathistory/list', { params }).then(res => {
        this.list = this.list.concat(res.data.data)
        if (res.data.data.length < 50) {
          this.islast = true
        } else {
          this.islast = false
        }
        this.loading = false
      })
    },
    getUserIofo() {
      const options = {
        source: 'AICC_WORKBENCH',
        param: this.$route.query.userId
      }
      getClientInfo(options.source, options.param).then(res => {
        res = res.data.data
        if (res && res.length > 0) {
          this.userInfo = res[0]
        }
      })
    },
    exportHistories() {
      const params = {
        agentId: this.$route.query.agentIds.toString(),
        sessionId: this.$route.query.sessionId
      }
      this.$http.get(window.$envUtils('VUE_APP_WB_SERVICE') + '/chathistory/export', { responseType: 'blob', params }).then(res => {
        const blob = new Blob([res.data])
        const fileName = 'chat_history' + Date.now() + '.xlsx'
        if ('download' in document.createElement('a')) {
          const alink = document.createElement('a')
          alink.download = fileName
          alink.style.display = 'none'
          alink.href = URL.createObjectURL(blob) // 这里是将文件流转化为一个文件地址
          document.body.appendChild(alink)
          alink.click()
          URL.revokeObjectURL(alink.href) // 释放URL 对象
          document.body.removeChild(alink)
        } else {
          // 其他浏览器
          navigator.msSaveBlob(blob, fileName)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    searchSlog() {
      this.$router.replace({
        name: 'workbench.sidebar_chatlog',
        params: {
          notkeepAlive: true,
          userId: this.$route.query.userId,
          isFromChatHistory: true
        }
      })
    },
    translateMessage(type, body) {
      if (type === 'image') {
        return '<img style="max-width:150px" src="' + this.resourceDownloadPath + body.url + '"/>'
      } else if (type === 'file') {
        return '<div style="min-width:200px;float:left"><img style="max-width:60px;float:left" src="./static/image/file.png"><a target="hide_iframe" href="' + this.resourceDownloadPath + body.url + '"><div style="margin-top:8px;padding-top:5px;text-decoration:underline;color:black;">' + (body.name.length > 15 ? body.name.substring(0, 15) + '...' : body.name) + '</div></a><div style="color:black">大小：' + body.size + '</div></div>'
      } else if (type === 'video') {
        return '<div><video style="width:100%" controls="controls" src="' + this.resourceDownloadPath + body.url + '"></video></div>'
      } else if (type === 'text') {
        body.content = body.content.replace('\n', '<br />')
        if (/\[.*?\]/g.test(body.content) || /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g.test(body.content)) {
          var emojis = this.emojis.emojis
          for (let i = 0; i < emojis.length; i++) {
            body.content = body.content.replace(emojis[i].reg, '<img src="./static/emoji/' + emojis[i].file + '"  alt="" style="vertical-align: middle; width: 24px; height: 24px" />')
          }
        }
        return body.content
      } else if (type === 'voice') {
        return body.recognition + '</br><audio controls><source src="' + this.resourceDownloadPath + body.url + '" type="audio/mpeg"><source src="' + this.resourceDownloadPath + body.url + '" type="audio/ogg">您的浏览器不支持该音频格式。</audio>'
      }
    },
    goBack() {
      this.$router.replace({
        name: 'workbench.sidebar_chatlog',
        params: {
          notkeepAlive: true,
          isFromChatHistory: true
        }
      })
    },
    hasApp(val) {
      return this.$store.state.user.appList && this.$store.state.user.appList.length > 0 && !!this.$store.state.user.appList.find(item => item.appId === val)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/chatlog/history.scss';
.item-label{
  width: 10px;
}
</style>
